import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-CreditCard',
  standalone: true,
  templateUrl: '../../assets/CreditCard.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCreditCardIcon {}
